import { render, staticRenderFns } from "./AcessarPedidoDocumentosListagem.vue?vue&type=template&id=45858376&scoped=true"
import script from "./AcessarPedidoDocumentosListagem.vue?vue&type=script&lang=js"
export * from "./AcessarPedidoDocumentosListagem.vue?vue&type=script&lang=js"
import style0 from "./AcessarPedidoDocumentosListagem.vue?vue&type=style&index=0&id=45858376&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45858376",
  null
  
)

export default component.exports